import { Injectable, Output, EventEmitter, OnInit } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class SharedDataService {
  public _comp1ValueBS: Subject<any> = new Subject();

  constructor() {}

  public project$: Subject<any> = new Subject();

  public updateComp1Val(val) {
    this._comp1ValueBS.next(val);
  }
}
